export type ComponentProps = {
  config: Widget;
}

export type Widget = {
  name: string;
  id: string;
  size: number;
  height?: WidgetHeight;
  component: (props: ComponentProps) => JSX.Element;
  page: string;
  tab?: string;
  detailsPagePath?: string;
  query?: string;
  isStandard?: boolean;
};

export enum WidgetHeight {
  S = 3,
  SM = 4,
  M = 6,
  L = 9,
  XL = 17
}